import { useTranslation } from 'react-i18next'

import { Widget, WidgetHeaderContentActionsAddButton } from '../../../Widget'

import {
  QA_NAME_VIEWING_APPLICANTS_ADD_BTN,
  QA_NAME_VIEWING_PROFILE_WIDGET_APPLICANTS,
} from './RentalPortalViewingProfileWidgetApplicants.constants'
import { useViewingApplicants } from './RentalPortalViewingProfileWidgetApplicants.hooks'
import { ViewingApplicantsContent } from './ViewingApplicantsContent'

function RentalPortalViewingProfileWidgetApplicants() {
  const { t } = useTranslation()

  const {
    applicants,
    canBookSlot,
    canManage,
    deletingApplicantId,
    handleDelete,
    handleSubmit,
    isInitiated,
    listingId,
  } = useViewingApplicants()

  const hasApplicants = applicants.length > 0

  const canAddApplicants = canManage && (hasApplicants || canBookSlot)

  const headerProps = {
    contentProps: {
      actionsProps: canAddApplicants
        ? {
            AdditionalActions: WidgetHeaderContentActionsAddButton,
            EditButton: null,
            additionalActionsProps: {
              qaName: QA_NAME_VIEWING_APPLICANTS_ADD_BTN,
              tooltipKey: 'RentalPortal.ViewingApplicantsAddBtnTooltipKey',
            },
          }
        : { AddButton: null, EditButton: null },
    },
  }

  return hasApplicants || canBookSlot || !isInitiated ? (
    <Widget
      headerProps={headerProps}
      isSkeleton={!isInitiated}
      qaName={QA_NAME_VIEWING_PROFILE_WIDGET_APPLICANTS}
      title={t('RentalPortal.ViewingApplicantsWidgetTitleKey')}
    >
      <ViewingApplicantsContent
        applicants={applicants}
        canManage={canManage}
        deletingApplicantId={deletingApplicantId}
        listingId={listingId}
        onDelete={handleDelete}
        onSubmit={handleSubmit}
      />
    </Widget>
  ) : null
}

export default RentalPortalViewingProfileWidgetApplicants
